module.exports = __webpack_public_path__ + "img/vehicleHomeTop2.aed79e07.png";